
import { SET_CARRIER_SEARCH_LIST } from '../actionTypes'

const initialState = []

export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_CARRIER_SEARCH_LIST:
        return action.carriers

    default:
        return state
    }
}
